import {
  LocalizedText,
  TranslationLanguage,
  TRANSLATION_LANGUAGES,
} from 'apollo/localizedTypes';

const hasText = (value?: string | null): boolean => Boolean(value && value.trim());

const getMissingLanguages = (
  texts: (LocalizedText | undefined | null)[]
): TranslationLanguage[] => {
  if (!texts.length) return [...TRANSLATION_LANGUAGES];

  return TRANSLATION_LANGUAGES.filter((language) =>
    texts.some((text) => !text || !hasText(text[language]))
  );
};

export default getMissingLanguages;
